const $ = require('jquery');

const FULL_SIZE_HERO_CLASS = '.hero--full-page';
// set to false if the menu is absolutely positioned over the hero
const MINUS_HEADER_HEIGHT = true;

if ($(FULL_SIZE_HERO_CLASS).length) {
  setFullPageHeroHeight();

  window.addEventListener('resize', setFullPageHeroHeight, {
    passive: true,
  });
}

function setFullPageHeroHeight() {
  let heightToUse;
  if (MINUS_HEADER_HEIGHT) {
    heightToUse = $(window).height() - $('.header.site-header').outerHeight();
  } else {
    heightToUse = $(window).height()
  }
  $(FULL_SIZE_HERO_CLASS).css('height', heightToUse);
}
